import React from "react";

const PHRASES = [
  "Handwoven Heritage",
  "Temple Borders",
  "Pure Ilkal Cotton",
  "Six Yards of Pride",
  "Loom to Wardrobe",
  "Made in Karnataka",
];

/** One slow editorial marquee — a quiet, typographic breathing moment. */
export const EditorialMarquee = () => (
  <section className="bg-ivory py-4 sm:py-5 overflow-hidden border-y border-gold/20" data-testid="editorial-marquee" aria-hidden="true">
    <div className="flex whitespace-nowrap animate-marquee-slow w-max">
      {[...PHRASES, ...PHRASES, ...PHRASES].map((text, i) => (
        <span key={i} className="inline-flex items-center">
          <span className={`font-heading text-3xl sm:text-5xl lg:text-6xl tracking-tight mx-6 sm:mx-10 ${i % 2 === 0 ? "text-maroon/90" : "italic text-gold font-light"}`}>
            {text}
          </span>
          <span className="text-gold/60 text-xl sm:text-2xl">✦</span>
        </span>
      ))}
    </div>
  </section>
);
